<template>
  <DashboardWidgetBarStack class="widget-andamento-vendite" title="Andamento delle Vendite" :dataY="dataY" :dataX="dataX" :legendData="legendData" />
</template>

<script>

export default {
  name: 'dashboard-widget-andamento-vendite',
  components: {
    DashboardWidgetBarStack: () => import('../BaseWidgets/DashboardWidgetBarStack'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      colours: ['#EC632B', '#2d9cde', 'rgba(45, 156, 222, .4)'],
      dataX: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    };
  },
  computed: {
    legendData () {
      return this.values.map(v => v.title);
    },
    dataY () {
      return this.values.map((v, pos) => {
        return {
          name: v.title,
          type: 'bar',
          data: v.values,
          barGap: 0,
          itemStyle: {
            color: this.colours[pos],
          },
        };
      });
    },
  },
};

</script>
